export default __webpack_public_path__ + "static/media/dark-top-desktop.eaba3435.webp";